<template>
  <router-view> </router-view>
  <!-- <Basic /> -->
</template>

<script>
import { onMounted, getCurrentInstance } from "vue";
import { useRouter, useRoute } from "vue-router";
import { throttle } from "@/utils/utils";
import { useMain } from "@/store/index";
export default {
  name: "App",
  setup() {
    const { $message, $bus } =
      getCurrentInstance().appContext.config.globalProperties;
    const useStoreMain = useMain();
    const router = useRouter();
    const route = useRoute();

    // const devOrProd = process.env.NODE_ENV == "development" ? "https://4031y7s390.yicp.fun" : "";
    // console.log(devOrProd)

    onMounted(() => {
      window.addEventListener("message", throttle(listenerMessage, 200), false);
    });

    function listenerMessage(event) {
      console.log("监听子组件发消息", event, event.data);
      // if (event.origin == "https://4031y7s390.yicp.fun") {
      const TRUSTED_ORIGINS = [
        "https://js.stripe.com"
      ];
      if (TRUSTED_ORIGINS.includes(event.origin)) {
        return;
      }

      let message = event.data;
      if (message && typeof message === "string") {
        let pathName = route.name;
        let userInfo = useStoreMain.userInfo;
        if (!userInfo || Object.keys(userInfo).length == 0) {
          if (pathName != "login") {
            $message.warning("Please login");
            router.push({ name: "login", params: { type: "type=login" } });
            return;
          }
        }

        if (message == "nopay") {
          if (pathName != "pay") {
            // $message.warning("Please subscribe to enjoy the service");
            router.push({ name: "pay" });
          }
        } else if(message == "question") {
          $bus.emit("openFeedback")
        } else if(message == "open") {
          $bus.emit("openBook")
        }
      }
      // }
    }
  },
};
</script>

<style lang="less" scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>>


